import { AdSlot } from '../../entities/ad-slot';
import { AdSlotContainer } from '../../entities/ad-slot-container';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class AdSlotContainerResolver {
  public async resolve (adSlot: AdSlot, elements: Element[]): Promise<AdSlotContainer[]> {
    const datasetId = adSlot.getSettings().getDatasetId();

    if (!datasetId) {
      throw new Error('Dataset ID is not defined');
    }

    // const elements = Array.from(this.browserObjectModel.getDocument().querySelectorAll<HTMLElement>(
    //   `[data-${datasetId}="${adSlot.getId()}"]`,
    // ));

    // @TODO: Implement position selector and inject type
    // if (elements.length === 0 && adSlot.getSettings().getPositionSelector()) {
    //   const positionSelector = adSlot.getSettings().getPositionSelector() as string;
    //
    //   elements = Array.from(this.browserObjectModel.getDocument().querySelectorAll<HTMLElement>(positionSelector));
    // }

    const adSlotContainers: AdSlotContainer[] = [];

    for (const element of elements) {
      if (element.getAttributeNames().includes('rendered') && element.getAttribute('data-rendered') === 'true') {
        continue;
      }

      const adSlotContainer = new AdSlotContainer();
      adSlotContainer.setElement(element as HTMLElement);

      adSlotContainers.push(adSlotContainer);
    }

    return adSlotContainers;
  }
}
